import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { LangProvider } from "@/contexts/LangContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Sites from "@/pages/Sites";
import SiteDetail from "@/pages/SiteDetail";
import Audits from "@/pages/Audits";
import AuditTerrain from "@/pages/AuditTerrain";
import Actions from "@/pages/Actions";
import DashboardNational from "@/pages/DashboardNational";
import Heatmap from "@/pages/Heatmap";
import Historique from "@/pages/Historique";
import Rapports from "@/pages/Rapports";
import Admin from "@/pages/Admin";
import Aide from "@/pages/Aide";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/confidentialite" element={<PolitiqueConfidentialite />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="sites" element={<Sites />} />
        <Route path="sites/:siteId" element={<SiteDetail />} />
        <Route path="audits" element={<Audits />} />
        <Route path="audits/:auditId" element={<AuditTerrain />} />
        <Route path="actions" element={<Actions />} />
        <Route path="dashboard" element={<DashboardNational />} />
        <Route path="heatmap" element={<Heatmap />} />
        <Route path="historique" element={<Historique />} />
        <Route path="rapports" element={<Rapports />} />
        <Route path="aide" element={<Aide />} />
        <Route path="admin" element={<Admin />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <AppRoutes />
            <Toaster position="top-center" />
          </LangProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
